<div cdkDropList [cdkDropListData]="questions" (cdkDropListDropped)="dropIds($event)">
  <div class="drag-wrapper" cdkDrag *ngFor="let question of questions">
    <icon class="handle" matIcon="drag_indicator" cdkDragHandle></icon>
    <grey-wrapper
      class="question-holder"
      (click)="editQuestion.emit(question)"
      >
      <div style="display: flex; align-items: start;">
        <div style="margin-right: 6px;" *ngIf="question.isMandatory">*</div>
        <div class="question" [innerHTML]="question.question || 'question without text'"></div>
        <div class="count" *ngIf="!!questionCounts && showCounts && question.type !== 'text'">&nbsp;({{ questionCounts[question.id] || 0 }})</div>
      </div>
      <div style="flex:1;"></div>
      <div class="question-type">{{ question.type === 'text' ? '' : 'Question type: ' + question.type}}</div>
      <div style="flex:1;"></div>
      <type-select-dropdown *ngIf="entityType"
        [ids]="question.typeIds"
        [types]="entityTypesMap"
        [entityType]="entityType"
        (selectIds)="updateQuestionIds.emit({ question: question, ids: $event })"
      ></type-select-dropdown>
      <dot-menu [dotMenuItems]="dotMenuItems" (select)="dotMenuSelection.emit({ dotEvent: $event, question: question })"></dot-menu>
    </grey-wrapper>
    
  </div>
</div>
<button class="secondary add-question" (click)="addQuestion.emit()">{{ addQuestionCopy }}</button>
<button class="secondary add-question" (click)="addQuestion.emit('text')">{{ addTextCopy }}</button>
